import PropTypes from "prop-types";
import HeaderTwo from "../wrappers/HeaderTwo";
import Footer from "../wrappers/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const LayoutTwo = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.replace(/\//g, "");
    document.body.classList.add(currentPath || "home");

    return () => {
      document.body.classList = "";
    };
  }, [location]);

  return (
    <>
      <HeaderTwo />
      {children}
      <Footer />
    </>
  );
};

LayoutTwo.propTypes = {
  children: PropTypes.node,
};

export default LayoutTwo;
